export enum UserColors {
    purple = "#745EC4",
    red = "#E84D3C",
    orange = "#E57D22",
    magenta = "#9A58B5",
    skyBlue = "#3498DB",
    gray = "#95A4A5",
    watermelon = "#EF7079",
    pink = "#F47CC4",
    lime = "#A6C63B",
    powderBlue = "#B8C9F2",
    mint = "#1ABC9C",
    yellow = "#FFCC02",
    blueDark = "#394C82",
    green = "#2ECC70",
    navyBlue = "#33495E",
    teal = "#3A7082",
    plum = "#5E335E",
    maroon = "#773029",
    coffee = "#A38570",
    blue = "#5065A0",
}
